import { useConfigStore } from '~/stores/config';
import { isPrivateRoute, isSchoolsIndexablePath, PRIVATE_ROUTE_ROBOTS_SETTING } from '~/utils/robots';

/**
 * PRIVATE_ROUTE_PREFIXES are defined in `~/utils/robots` or can be set in
 * `definePageMeta({ robots: PRIVATE_ROUTE_ROBOTS_SETTING });`.
 */
export default defineNuxtRouteMiddleware((to) => {
  const path = to.path;
  let robotSetting = to.meta.robots;

  if (isPrivateRoute(path)) {
    robotSetting = PRIVATE_ROUTE_ROBOTS_SETTING
  }

  // A schools cluster's SEO surface is SCHOOLS_INDEXABLE_PATHS, its public marketing
  // landings and the demo request they feed. All other content is login-walled, so every
  // other route is noindexed regardless of page meta. The schoolsSeo nitro plugin mirrors
  // this on the X-Robots-Tag response header.
  if (useConfigStore().isSchoolsCluster && !isSchoolsIndexablePath(path)) {
    robotSetting = PRIVATE_ROUTE_ROBOTS_SETTING;
  }

  if (import.meta.server) {
    const event = useRequestEvent();
    const headerValue = event?.node.req.headers['x-robots-tag'];
    if (typeof headerValue === 'string') {
      robotSetting = headerValue;
    }
  }

  if (typeof robotSetting === 'string') {
    useHead(() => {
      return {
        meta: [
          {
            name: 'robots',
            content: robotSetting,
          },
        ],
      };
    })
  }
});
